import React from "react";

export const SHOW_NAME = "Jewellery Sahi Hai";
export const SHOW_HOST = "Shubham S. Bapna";

export function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
}

export function fmtMinutes(s) {
  if (!s) return "";
  const m = Math.round(s / 60);
  return m >= 60 ? `${Math.floor(m / 60)} hr ${m % 60} min` : `${m} min`;
}

export function isoDuration(s) {
  const n = Math.max(0, Math.floor(s || 0));
  return `PT${Math.floor(n / 3600) ? `${Math.floor(n / 3600)}H` : ""}${Math.floor((n % 3600) / 60)}M${n % 60}S`;
}

// Cover art from the feed; until one exists, a plain typographic tile (no stock imagery).
export function ShowCover({ src, className = "", testid = "podcast-cover" }) {
  if (src) return <img src={src} alt={`${SHOW_NAME} cover art`} className={`aspect-square rounded-[10px] border border-border object-cover ${className}`} data-testid={testid} />;
  return (
    <div className={`flex aspect-square flex-col justify-end rounded-[10px] bg-[#14110D] p-4 ${className}`} data-testid={testid} aria-label={`${SHOW_NAME} cover`}>
      <span className="kicker text-[10px] text-[#C9A227]">Podcast</span>
      <span className="mt-1 font-heading text-lg font-extrabold leading-tight text-[#F4F1EA]">Jewellery<br />Sahi Hai</span>
    </div>
  );
}

export const PODCAST_PROMISE = "Get each new episode of Jewellery Sahi Hai by email, the morning it goes out.";
export const PODCAST_DONE = "We've sent a one-click confirmation link. Confirm it and you'll hear about episode one the day it's out.";
